const REGION_CODES = [
  "AF", "AX", "AL", "DZ", "AS", "AD", "AO", "AI", "AQ", "AG", "AR", "AM", "AW", "AU", "AT", "AZ",
  "BS", "BH", "BD", "BB", "BY", "BE", "BZ", "BJ", "BM", "BT", "BO", "BQ", "BA", "BW", "BV", "BR",
  "IO", "BN", "BG", "BF", "BI", "CV", "KH", "CM", "CA", "KY", "CF", "TD", "CL", "CN", "CX", "CC",
  "CO", "KM", "CG", "CD", "CK", "CR", "CI", "HR", "CU", "CW", "CY", "CZ", "DK", "DJ", "DM", "DO",
  "EC", "EG", "SV", "GQ", "ER", "EE", "SZ", "ET", "FK", "FO", "FJ", "FI", "FR", "GF", "PF", "TF",
  "GA", "GM", "GE", "DE", "GH", "GI", "GR", "GL", "GD", "GP", "GU", "GT", "GG", "GN", "GW", "GY",
  "HT", "HM", "VA", "HN", "HK", "HU", "IS", "IN", "ID", "IR", "IQ", "IE", "IM", "IL", "IT", "JM",
  "JP", "JE", "JO", "KZ", "KE", "KI", "KP", "KR", "KW", "KG", "LA", "LV", "LB", "LS", "LR", "LY",
  "LI", "LT", "LU", "MO", "MG", "MW", "MY", "MV", "ML", "MT", "MH", "MQ", "MR", "MU", "YT", "MX",
  "FM", "MD", "MC", "MN", "ME", "MS", "MA", "MZ", "MM", "NA", "NR", "NP", "NL", "NC", "NZ", "NI",
  "NE", "NG", "NU", "NF", "MK", "MP", "NO", "OM", "PK", "PW", "PS", "PA", "PG", "PY", "PE", "PH",
  "PN", "PL", "PT", "PR", "QA", "RE", "RO", "RU", "RW", "BL", "SH", "KN", "LC", "MF", "PM", "VC",
  "WS", "SM", "ST", "SA", "SN", "RS", "SC", "SL", "SG", "SX", "SK", "SI", "SB", "SO", "ZA", "GS",
  "SS", "ES", "LK", "SD", "SR", "SJ", "SE", "CH", "SY", "TW", "TJ", "TZ", "TH", "TL", "TG", "TK",
  "TO", "TT", "TN", "TR", "TM", "TC", "TV", "UG", "UA", "AE", "GB", "US", "UM", "UY", "UZ", "VU",
  "VE", "VN", "VG", "VI", "WF", "EH", "YE", "ZM", "ZW",
];

export const COUNTRY_OPTIONS = REGION_CODES
  .map((code) => {
    try {
      return new Intl.DisplayNames(["en"], { type: "region" }).of(code);
    } catch {
      return code;
    }
  })
  .filter(Boolean)
  .sort((a, b) => a.localeCompare(b));

export const TIMEZONE_OPTIONS = (() => {
  const fallback = [
    "UTC", "Etc/UTC", "Africa/Cairo", "Africa/Johannesburg", "America/New_York", "America/Chicago",
    "America/Denver", "America/Los_Angeles", "America/Toronto", "America/Vancouver", "America/Sao_Paulo",
    "Asia/Kolkata", "Asia/Dubai", "Asia/Singapore", "Asia/Tokyo", "Asia/Shanghai", "Asia/Seoul",
    "Australia/Sydney", "Australia/Melbourne", "Europe/London", "Europe/Berlin", "Europe/Paris",
    "Europe/Rome", "Europe/Madrid",
  ];
  if (typeof Intl.supportedValuesOf === "function") {
    return Array.from(new Set(["UTC", "Etc/UTC", ...Intl.supportedValuesOf("timeZone")]))
      .sort((a, b) => a.localeCompare(b));
  }
  return fallback.sort((a, b) => a.localeCompare(b));
})();

const IANA_LOCATION_CITY_OPTIONS = TIMEZONE_OPTIONS
  .map((zone) => zone.split("/").slice(1).join("/"))
  .filter(Boolean)
  .flatMap((name) => {
    const cleaned = name.replace(/^Argentina\//, "").replace(/^Indiana\//, "").replace(/^Kentucky\//, "");
    return cleaned.split("/").map((part) => part.replace(/_/g, " "));
  })
  .filter((name) => name && !name.startsWith("GMT") && name !== "UTC");

const CURATED_CITY_OPTIONS = [
  "Ahmedabad", "Amsterdam", "Athens", "Atlanta", "Auckland", "Austin", "Bangkok", "Barcelona",
  "Beijing", "Bengaluru", "Berlin", "Boston", "Brisbane", "Brussels", "Buenos Aires", "Cairo",
  "Cape Town", "Chennai", "Chicago", "Copenhagen", "Dallas", "Delhi", "Denver", "Dubai", "Dublin",
  "Frankfurt", "Gurugram", "Helsinki", "Hong Kong", "Hyderabad", "Istanbul", "Jakarta", "Johannesburg",
  "Kolkata", "Kuala Lumpur", "Lisbon", "London", "Los Angeles", "Madrid", "Melbourne", "Mexico City",
  "Miami", "Milan", "Montreal", "Mumbai", "Munich", "New York", "Osaka", "Oslo", "Paris", "Pune",
  "Rio de Janeiro", "Rome", "San Francisco", "Santiago", "Sao Paulo", "Seattle", "Seoul", "Shanghai",
  "Singapore", "Stockholm", "Sydney", "Taipei", "Tel Aviv", "Tokyo", "Toronto", "Vancouver", "Vienna",
  "Warsaw", "Washington", "Zurich",
];

export const CITY_OPTIONS = Array.from(new Set([...CURATED_CITY_OPTIONS, ...IANA_LOCATION_CITY_OPTIONS]))
  .sort((a, b) => a.localeCompare(b));
